// JS
import { getAuth } from "firebase/auth";

export async function registerLlm(pyodide) {
  const auth = getAuth();
  const userId = auth.currentUser?.uid || "no-user";
  // Create a *synchronous* Python wrapper module named "llm"
  await pyodide.runPythonAsync(`
import sys, types
from pyodide.http import open_url
import json
from urllib.parse import quote

m = types.ModuleType("llm")

def string_pr(text: str):
    text = quote(text)
    url = f"https://us-central1-guia-cs109psets.cloudfunctions.net/llmStringPrRequestable?text={text}&userId=${userId}"
    # open_url returns a file-like object
    response = open_url(url)
    data = json.load(response)
    # get the "result"
    return data["result"]


m.string_pr = string_pr
sys.modules["llm"] = m
  `);
}